import { _request,APIBaseResponse, APIMethod } from '../index';
import { RequestParamsBase } from '../Models/CommonRequestModels';

const TENANTS_PATH_PREFIX = '/tenants';
const USER_ROLE_PATH_PREFIX = 'userrolememberships';

type APIUserRoleMembershipListParams = RequestParamsBase & {
    tenantId: string;
    userId: string;
};

type APIUserRoleMembershipListResponse = APIBaseResponse<Array<{
    roleId: string;
    userId: string;
    roleName: string;
}>>;

type APIUserRoleMembershipDeleteParams = {
    tenantId: string;
    userId: string;
    roleId: string;
};

type APIUserRoleMembershipPostParams = {
    tenantId: string;
    roleId: string;
    userId: string;
}

type APIUserRoleMembershipDeleteResponse = APIBaseResponse;
type APIUserRoleMembershipPostResponse = APIBaseResponse;

export const APIUserRoleMembershipGetList: APIMethod<APIUserRoleMembershipListParams, APIUserRoleMembershipListResponse> = params => (
    _request('GET', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USER_ROLE_PATH_PREFIX}?userId=${params.userId}`, undefined, params.signal)
);

export const APIUserRoleMembershipDelete: APIMethod<APIUserRoleMembershipDeleteParams, APIUserRoleMembershipDeleteResponse> = params => (
    _request('DELETE', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USER_ROLE_PATH_PREFIX}?userId=${params.userId}&roleId=${params.roleId}`)
);

export const APIUserRoleMembershipPost: APIMethod<APIUserRoleMembershipPostParams, APIUserRoleMembershipPostResponse> = params => (
    _request('POST', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USER_ROLE_PATH_PREFIX}`, params)
);
